"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTermsAndConditions = exports.fetchTermsAndConditions = exports.renewUrl = exports.verifyStatus = exports.verifyIdentity = exports.instagramGetOAuthToken = exports.twitterGetOAuthToken = exports.twitterGetRequestToken = exports.refreshAccount = exports.socialConnect = exports.updateBillingAddress = exports.updateProfile = exports.getProfile = void 0;
var profile_1 = require("@pbl/pbl-react-core/lib/models/profile");
var types_1 = require("@pbl/pbl-react-core/lib/models/profile/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../action-type.util");
var actions_1 = require("../app/actions");
var actions_2 = require("../authentication/actions");
var getProfile = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, 3, 4]);
                dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                return [4, dispatch({
                        type: types_1.GET_PROFILE,
                        payload: services_1.ProfileService.getProfileV2()
                    })];
            case 1:
                _b.sent();
                return [3, 4];
            case 2:
                e_1 = _b.sent();
                dispatch((0, actions_1.showMessageBar)({ message: (_a = e_1.payload) === null || _a === void 0 ? void 0 : _a.error, type: 'error' }));
                return [3, 4];
            case 3:
                dispatch((0, actions_1.clearLoading)());
                return [7];
            case 4: return [2];
        }
    });
}); }; };
exports.getProfile = getProfile;
var updateProfile = function (data) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var userProfile, requestData, updateSucceeded, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch((0, actions_1.clearMessages)());
                userProfile = getState().profile.userProfile;
                requestData = profile_1.ProfileData.getPutRequest(data, userProfile, constants_1.default.LOTTERY_ID);
                return [4, dispatch({
                        type: types_1.UPDATE_PROFILE,
                        payload: services_1.ProfileService.updateProfileV2(requestData)
                    })];
            case 1:
                _a.sent();
                updateSucceeded = getState().profile.updateSucceeded;
                if (updateSucceeded) {
                    dispatch((0, actions_1.showMessageBar)({ message: 'profile.updated' }));
                    dispatch((0, actions_2.getAccount)());
                }
                return [3, 3];
            case 2:
                e_2 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_2.payload.error, type: 'error' }));
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.updateProfile = updateProfile;
var updateBillingAddress = function (data) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var userProfile, requestData, updateSucceeded, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch((0, actions_1.clearMessages)());
                userProfile = getState().profile.userProfile;
                requestData = profile_1.ProfileData.getPutRequestBilling(data, userProfile, constants_1.default.LOTTERY_ID);
                return [4, dispatch({
                        type: types_1.UPDATE_PROFILE,
                        payload: services_1.ProfileService.updateProfileV2(requestData)
                    })];
            case 1:
                _a.sent();
                updateSucceeded = getState().profile.updateSucceeded;
                if (updateSucceeded) {
                    dispatch((0, actions_1.showMessageBar)({ message: 'profile.updated' }));
                    dispatch((0, actions_2.getAccount)());
                }
                return [3, 3];
            case 2:
                e_3 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_3.payload.error, type: 'error' }));
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.updateBillingAddress = updateBillingAddress;
var socialConnect = function (provider, data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                dispatch((0, actions_1.clearMessages)());
                dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                return [4, dispatch({
                        type: types_1.SOCIAL_CONNECT,
                        payload: services_1.ProfileService.socialConnect(provider, data)
                    })];
            case 1:
                _a.sent();
                return [4, dispatch((0, actions_2.getAccount)())];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                e_4 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_4.payload.error, type: 'error' }));
                return [3, 5];
            case 4:
                dispatch((0, actions_1.toggleLoading)({ spinning: false }));
                return [7];
            case 5: return [2];
        }
    });
}); }; };
exports.socialConnect = socialConnect;
var refreshAccount = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                dispatch((0, actions_1.clearMessages)());
                dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                return [4, dispatch((0, actions_2.getAccount)())];
            case 1:
                _a.sent();
                return [3, 4];
            case 2:
                e_5 = _a.sent();
                dispatch((0, actions_1.showMessageBar)({ message: e_5.payload.error, type: 'error' }));
                return [3, 4];
            case 3:
                dispatch((0, actions_1.toggleLoading)({ spinning: false }));
                return [7];
            case 4: return [2];
        }
    });
}); }; };
exports.refreshAccount = refreshAccount;
var twitterGetRequestToken = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_TWITTER_REQUEST_TOKEN,
                        payload: services_1.SocialService.getTwitterRequestToken()
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_6 = _a.sent();
                throw e_6;
            case 3: return [2];
        }
    });
}); }; };
exports.twitterGetRequestToken = twitterGetRequestToken;
var twitterGetOAuthToken = function (oauthVerifier, oauthToken) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_TWITTER_OAUTH_TOKEN,
                        payload: services_1.SocialService.getTwitterOauthToken(oauthVerifier, oauthToken)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_7 = _a.sent();
                throw e_7;
            case 3: return [2];
        }
    });
}); }; };
exports.twitterGetOAuthToken = twitterGetOAuthToken;
var instagramGetOAuthToken = function (code, redirectUrl) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_INSTAGRAM_ACCESS_TOKEN,
                        payload: services_1.SocialService.getInstagramRequestToken(code, redirectUrl)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_8 = _a.sent();
                throw e_8;
            case 3: return [2];
        }
    });
}); }; };
exports.instagramGetOAuthToken = instagramGetOAuthToken;
var verifyIdentity = function (playerDetails, suc, err) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var userProfile, payload, e_9;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, , 6]);
                userProfile = getState().profile.userProfile;
                return [4, services_1.ProfileService.verifyId({
                        id: userProfile.id,
                        lotteryId: constants_1.default.LOTTERY_ID,
                        login: userProfile.login,
                        firstName: playerDetails.firstName,
                        lastName: playerDetails.lastName,
                        birthDate: playerDetails.dateOfBirth,
                        email: playerDetails.email,
                        phones: [{ phone: playerDetails.phone1 }],
                        addresses: [
                            {
                                id: ((_c = (_b = (_a = userProfile.addresses) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.addressTypeId === types_1.AddressType.HOME; })) === null || _b === void 0 ? void 0 : _b.map(function (x) { return x.id; })) === null || _c === void 0 ? void 0 : _c[0]) || null,
                                address1: playerDetails.address1,
                                state: playerDetails.state,
                                city: playerDetails.city,
                                countryCode: playerDetails.countryCode,
                                country: playerDetails.country,
                                zipCode: playerDetails.zip,
                                stateCode: playerDetails.stateCode
                            }
                        ]
                    })];
            case 1:
                payload = _d.sent();
                return [4, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.VERIFY_PROFILE),
                        payload: payload
                    })];
            case 2:
                _d.sent();
                suc === null || suc === void 0 ? void 0 : suc(payload);
                if (!payload.verified) return [3, 4];
                return [4, dispatch((0, actions_1.showMessageBar)({ message: 'profile.updated' }))];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4: return [3, 6];
            case 5:
                e_9 = _d.sent();
                console.error('Unable to verify identity', e_9);
                err === null || err === void 0 ? void 0 : err(e_9);
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.verifyIdentity = verifyIdentity;
var verifyStatus = function (success) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4, services_1.ProfileService.verifyStatus()];
            case 1:
                response = _a.sent();
                return [4, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.VERIFY_STATUS),
                        payload: response
                    })];
            case 2:
                _a.sent();
                success === null || success === void 0 ? void 0 : success(response);
                return [3, 4];
            case 3:
                e_10 = _a.sent();
                console.error('Unable to verify identity status', e_10);
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.verifyStatus = verifyStatus;
var renewUrl = function (success, error) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 5, 6]);
                dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                return [4, services_1.ProfileService.renewIdologyUrl()];
            case 1:
                response = _a.sent();
                return [4, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.RENEW_IDOLOGY_URL),
                        payload: response
                    })];
            case 2:
                _a.sent();
                success(response);
                return [3, 6];
            case 3:
                e_11 = _a.sent();
                return [4, dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.RENEW_IDOLOGY_URL)
                    })];
            case 4:
                _a.sent();
                error();
                return [3, 6];
            case 5:
                dispatch((0, actions_1.clearLoading)());
                return [7];
            case 6: return [2];
        }
    });
}); }; };
exports.renewUrl = renewUrl;
var fetchTermsAndConditions = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                return [4, services_1.ProfileService.fetchTermsAndConditions()];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_TERMS_AND_CONDITIONS),
                    payload: response === null ? false : response
                });
                return [3, 4];
            case 2:
                e_12 = _a.sent();
                return [4, dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.GET_TERMS_AND_CONDITIONS)
                    })];
            case 3:
                _a.sent();
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.fetchTermsAndConditions = fetchTermsAndConditions;
var updateTermsAndConditions = function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.ProfileService.updateTermsAndConditions()];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                e_13 = _a.sent();
                console.error('Unable to update the users Terms and Conditons acceptance', e_13);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.updateTermsAndConditions = updateTermsAndConditions;
//# sourceMappingURL=actions.js.map